import { JSONContent } from '@tiptap/react'

/** @description count the text characters of a markdown */
export function countMarkdownText(
  content: JSONContent,
  totalCount: number = 0
): number {
  /** text content length */
  const mentions: string | undefined =
    content.type === 'mention' && content.attrs?.id
      ? content.attrs.id.split('/')[1]
      : ''

  const count =
    (mentions?.length ?? 0) + (content.text?.length ?? 0) + totalCount

  /** if no children, return only text length */
  if (!content.content?.length) return count

  /** accumulated children length */
  const accumulatedCount = content.content.reduce(
    (totalCount: number, content) => {
      const accumulatedCount = countMarkdownText(content, totalCount)
      return accumulatedCount
    },
    count
  )

  return accumulatedCount
}
